import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.css';

function Breadcrumb({ currentLabel, items = [] }) {
  const location = useLocation();
  const parts = location.pathname.split('/').filter(Boolean);
  const breadcrumbItems = items.length > 0
    ? [...items, { label: currentLabel || parts.at(-1)?.replace(/-/g, ' '), current: true }]
    : parts.map((part, index) => ({
      label: index === parts.length - 1 && currentLabel
        ? currentLabel
        : decodeURIComponent(part).replace(/-/g, ' '),
      to: '/' + parts.slice(0, index + 1).join('/'),
      current: index === parts.length - 1
    }));

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ul>
        <li><Link to="/">Home</Link></li>
        {breadcrumbItems.map((item) => (
          <li key={`${item.to || 'current'}-${item.label}`} aria-current={item.current ? 'page' : undefined}>
            {item.current ? <span>{item.label}</span> : <Link to={item.to}>{item.label}</Link>}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Breadcrumb;
